import * as api from "api/Core";
import * as kapi from "api/Knowledge";
import { RequestIndicator } from "components/CallServer";
import { WithSnackbar, withSnackbar } from "components/SnackbarProvider/Snackbar";
import { TextPluralization } from "components/TextPluralization";
import { PublicationAdminCourseDto } from "models/ApiModels";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { MemberAutoCompleteSearchParams } from "views/Member/Components/MemberAutoComplete";
import MemberSelectionDrawer from "views/Member/Dialogs/MemberSelectionDrawer";

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    course: PublicationAdminCourseDto;
    onClose: (count: number) => void;
}

interface IState {
    updating: boolean;
}

type Props = IProps & WithSnackbar & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

class CourseEnrollDrawer extends React.PureComponent<Props, IState>
{
    constructor(props: Props) {
        super(props);
        this.state = { updating: false };
    }

    private apiGetSuggestions = api.getCourseEnrollMembersSuggestions();

    ///
    public render() {
        const { course, snackbar, onClose } = this.props;
        return (
            <>
                <RequestIndicator open={this.state.updating} type="waiting" />

                <MemberSelectionDrawer
                    title={this.props.t("Views.Publication.Dialogs.CourseEnrollDrawer.BoxTitle")}
                    subtitle={course.title}
                    buttonText={this.props.t("Common.Buttons.AddText")}
                    onCustomGetMembers={
                        (p: MemberAutoCompleteSearchParams) => this.apiGetSuggestions.execute({
                            courseId: this.props.course.publicationId,
                            searchText: p.searchText,
                            offset: p.offset,
                            take: p.take
                        })
                    }
                    onClose={(members) => {
                        if (members && members.length > 0) {
                            this.setState({ updating: true },
                                () => {
                                    kapi.courseBatchEnroll(course.publicationId, members)
                                        .then((count) => {
                                            snackbar.showMessage(
                                                <TextPluralization
                                                    count={count}
                                                    resource="Views.Publication.Dialogs.CourseEnrollDrawer.ResultText"
                                                />, "success"
                                            );
                                            onClose(count);
                                        })
                                        .catch(() => {
                                            snackbar.showMessage(this.props.t("Views.Publication.Dialogs.CourseEnrollDrawer.SaveError"), "error");
                                            onClose(null);
                                        });
                                }
                            );
                        }
                        else
                            onClose(null);
                    }}
                />
            </>
        );
    }
}

export default withSnackbar(withTranslation()(CourseEnrollDrawer));